var _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDependencies = function SvgDependencies(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M71.483 19.183H66.38l-7.992 7.992v5.103l7.992 7.992h5.103l7.992-7.992v-5.103l-7.992-7.992ZM46.965 35.921l4.648-5.335v-1.723l-4.648-5.205M51.726 29.79H34.548M44.766 45.458l.486 7.059 1.219 1.219 6.967.394M45.736 53.16 63.17 35.726M34.548 24.066l-3.614-3.613h-11.32L16 24.066v11.32l3.614 3.615h11.32l3.614-3.614v-11.32Z",
    stroke: "currentColor",
    strokeWidth: 3
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.02,
    cy: 64.805,
    r: 9.746,
    stroke: "currentColor",
    strokeWidth: 3
  })));
};
export default SvgDependencies;